import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FilterSidebar from 'components/search_sidebar/filter_sidebar';

export default class CallListSidebar extends React.Component {
  static propTypes = {
    activeCallListId: PropTypes.number,
    callLists: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      })
    ).isRequired,
    onListClick: PropTypes.func.isRequired,
  };

  handleListClick = id => (e) => {
    e.preventDefault();
    this.props.onListClick(id);
  }

  render() {
    return (
      <FilterSidebar {...this.props}>
        <div className="call-lists-sidebar">
          <ul className="list-unstyled">
            {
              this.props.callLists.map((callList) => {
                const className = classNames({
                  'call-list-item': true,
                  'clickable': true,
                  'selected-call-list-item': this.props.activeCallListId === callList.id
                });

                return (
                  <li
                    className={className}
                    key={`call-list-${callList.id}`}
                    onClick={this.handleListClick(callList.id)}
                  >
                    {callList.name}
                  </li>
                );
              })
            }
          </ul>
        </div>
      </FilterSidebar>
    );
  }
}
